<div class="payment-method-logo sports-only payment-method-{{ usedOption()?.paymentMethod }}"></div>
<div class="payment-text">
    @if (usedOption()?.paymentMethod?.toUpperCase() === 'INSTANTECHECKS') {
        <span>{{ 'PARTY.CASHIER.web.deposit.instantechecks.name.us' | translate }}</span>
    }
    @if (usedOption()?.paymentMethod?.toUpperCase() === 'INTERCHECKS_ACH') {
        <span class="payment-name">{{ 'PARTY.CASHIER.web.deposit.achInterchecks.name' | translate }}</span>
    }
    @if (usedOption()?.paymentMethod?.toUpperCase() === 'BORGATAPREPAIDCARD') {
        <span>{{ 'PARTY.CASHIER.web.deposit.ewallet.play.name.us' | translate }}</span>
    }
    @if (usedOption()?.paymentMethod?.toUpperCase() === 'PLAYMGMPREPAIDCARD') {
        <span>{{ 'PARTY.CASHIER.web.deposit.ewallet.betmgmplay.name.us' | translate }}</span>
    }
    @if (usedOption()?.paymentMethod?.toUpperCase() === 'MLIFE') {
        <span>{{ 'PARTY.CASHIER.web.deposit.mgmrewards.name' | translate }}</span>
    }
    @if (
        !(
            usedOption()?.paymentMethod?.toUpperCase() === 'APPLEPAYDIRECT' ||
            prepaidCardsAndEchecks.includes(usedOption()?.paymentMethod?.toUpperCase())
        )
    ) {
        <span>{{ usedOption()?.paymentText }}</span>
    }
    @if (usedOption()?.paymentMethod?.toUpperCase() === 'APPLEPAYDIRECT') {
        <span>
            {{ 'PARTY.CASHIER.web.deposit.applepaydirect.name' | translate }}
        </span>
    }
    @if (!['APPLEPAYDIRECT'].includes(usedOption()?.paymentMethod?.toUpperCase())) {
        <span> {{ usedOption()?.instrumentNumber }}</span>
    }
</div>
@if (usedOption()?.sportsOnly && !usedOption()?.bankAccountsOnly) {
    <div>
        <div class="sports-only-ribbon">
            <div class="ribbon-text">{{ 'PARTY.CASHIER.web.deposit.sports.only.ribbon.text' | translate }}</div>
        </div>
    </div>
}
@if (usedOption()?.bankAccountsOnly && !usedOption()?.sportsOnly) {
    <div>
        @if (isUSLabel()) {
            <div class="sports-only-ribbon wp-66">
                <div class="ribbon-text">{{ 'PARTY.CASHIER.web.deposit.bank.accounts.only.ribbon.text' | translate }}</div>
            </div>
        }
    </div>
}
